import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _deviceSizeToBreakpoi, _mediaQueryByPageType;
import { useState, useEffect, useCallback, useContext } from 'react';
import { TypePage } from '@vtblife/block-kit-types';
import { BlockKitContext } from './../contexts/context';
var isMatchMediaEnabled = true;
export function setIsMatchMediaEnabled(_isMatchMediaEnabled) {
  isMatchMediaEnabled = _isMatchMediaEnabled;
}
export function matchMedia(query) {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function' || !isMatchMediaEnabled) {
    return false;
  }
  return window.matchMedia(query).matches;
}
export function isMarquizScreenSAndLesser() {
  return matchMedia('screen and (max-width: 866px)');
}
export function isScreenXS() {
  return matchMedia('screen and (max-width: 767px)');
}
export function isScreenSAndLesser() {
  return matchMedia('screen and (max-width: 959px)');
}
export function isScreenS() {
  return matchMedia('screen and (min-width: 768px) and (max-width: 959px)');
}
export function isScreenSAndGreater() {
  return matchMedia('screen and (min-width: 768px)');
}
export function isScreenMAndLesser() {
  return matchMedia('screen and (max-width: 1199px)');
}
export function isScreenM() {
  return matchMedia('screen and (min-width: 960px) and (max-width: 1199px)');
}
export function isScreenMAndGreater() {
  return matchMedia('screen and (min-width: 960px)');
}
export function isScreenLAndLesser() {
  return matchMedia('screen and (max-width: 1419px)');
}
export function isScreenL() {
  return matchMedia('screen and (min-width: 1200px) and (max-width: 1419px)');
}
export function isScreenLAndGreater() {
  return matchMedia('screen and (min-width: 1200px)');
}
export function isScreenXL() {
  return matchMedia('screen and (min-width: 1420px)');
}
export var DeviceSize;
(function (DeviceSize) {
  DeviceSize[DeviceSize["XS"] = 1] = "XS";
  DeviceSize[DeviceSize["S"] = 2] = "S";
  DeviceSize[DeviceSize["M"] = 3] = "M";
  DeviceSize[DeviceSize["L"] = 4] = "L";
  DeviceSize[DeviceSize["XL"] = 5] = "XL";
})(DeviceSize || (DeviceSize = {}));
export var deviceSizeToBreakpointMap = (_deviceSizeToBreakpoi = {}, _defineProperty(_deviceSizeToBreakpoi, DeviceSize.XL, 'xl'), _defineProperty(_deviceSizeToBreakpoi, DeviceSize.L, 'l'), _defineProperty(_deviceSizeToBreakpoi, DeviceSize.M, 'm'), _defineProperty(_deviceSizeToBreakpoi, DeviceSize.S, 's'), _defineProperty(_deviceSizeToBreakpoi, DeviceSize.XS, 'xs'), _deviceSizeToBreakpoi);
var mediaQueryByPageType = (_mediaQueryByPageType = {}, _defineProperty(_mediaQueryByPageType, TypePage.Narrow, {
  screenXS: 'screen and (max-width: 767px)',
  screenSAndLesser: 'screen and (max-width: 959px)',
  screenS: 'screen and (min-width: 768px) and (max-width: 959px)',
  screenSAndGreater: 'screen and (min-width: 768px)',
  screenMAndLesser: 'screen and (max-width: 1199px)',
  screenM: 'screen and (min-width: 960px) and (max-width: 1199px)',
  screenMAndGreater: 'screen and (min-width: 960px)',
  screenLAndLesser: 'screen and (max-width: 1419px)',
  screenL: 'screen and (min-width: 1200px) and (max-width: 1419px)',
  screenLAndGreater: 'screen and (min-width: 1200px)',
  screenXL: 'screen and (min-width: 1420px)'
}), _defineProperty(_mediaQueryByPageType, TypePage.Sidebar, {
  screenXS: 'screen and (max-width: 830px)',
  screenSAndLesser: 'screen and (max-width: 1022px)',
  screenS: 'screen and (min-width: 831px) and (max-width: 1022px)',
  screenSAndGreater: 'screen and (min-width: 831px)',
  screenMAndLesser: 'screen and (max-width: 1487px)',
  screenM: 'screen and (min-width: 1023px) and (max-width: 1487px)',
  screenMAndGreater: 'screen and (min-width: 1023px)',
  screenLAndLesser: 'screen and (max-width: 1787px)',
  screenL: 'screen and (min-width: 1488px) and (max-width: 1787px)',
  screenLAndGreater: 'screen and (min-width: 1488px)',
  screenXL: 'screen and (min-width: 1788px)'
}), _mediaQueryByPageType);
function calculateDeviceSize(pageType) {
  var mediaQuery = mediaQueryByPageType[pageType];
  if (matchMedia(mediaQuery.screenXS)) {
    return DeviceSize.XS;
  }
  if (matchMedia(mediaQuery.screenS)) {
    return DeviceSize.S;
  }
  if (matchMedia(mediaQuery.screenM)) {
    return DeviceSize.M;
  }
  if (matchMedia(mediaQuery.screenL)) {
    return DeviceSize.L;
  }
  if (matchMedia(mediaQuery.screenXL)) {
    return DeviceSize.XL;
  }
  return DeviceSize.XL;
}
export function useDeviceSize() {
  var pageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TypePage.Narrow;
  var _useState = useState(calculateDeviceSize(pageType)),
    _useState2 = _slicedToArray(_useState, 2),
    deviceSize = _useState2[0],
    setDeviceSize = _useState2[1];
  var resizeHandler = useCallback(function () {
    setDeviceSize(calculateDeviceSize(pageType));
  }, [pageType]);
  useEffect(function () {
    window.addEventListener('resize', resizeHandler);
    return function () {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [resizeHandler]);
  return deviceSize;
}
export function useCurrentBreakpoint() {
  var _a;
  var typePage = (_a = useContext(BlockKitContext)) === null || _a === void 0 ? void 0 : _a.typePage;
  var deviceSize = useDeviceSize(typePage);
  return deviceSizeToBreakpointMap[deviceSize];
}